'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilitySelector = require('./components/VisibilitySelector.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilitySelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-selector/index.js
// module id = 1355
// module chunks = 0